import { css } from '@emotion/css'
import { fontFamily, fontSize } from '../../styles'
import { colors } from '../../themes'

const styles = {
  wrapper: css({
    fontFamily: fontFamily.heading,
    fontSize: fontSize.medium,
    fontWeight: 'inherit',
    lineHeight: 1.2,
    color: colors.oxfordBlue,
    margin: 0,
  }),
}

export default styles
